import { render } from "./Test.vue?vue&type=template&id=4069e24b&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=4069e24b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4069e24b"]])

export default __exports__